import { create } from "zustand";
import type { CustomBlock } from "@/types/email";

interface CustomBlocksState {
  blocks: CustomBlock[];
  isLoading: boolean;
  error: string | null;

  // Actions
  fetchCustomBlocks: (category?: string) => Promise<void>;
  saveCustomBlock: (data: {
    name: string;
    description?: string;
    category?: string;
    blockId: string;
  }) => Promise<void>;
  deleteCustomBlock: (id: string) => Promise<void>;
  reset: () => void;
}

export const useCustomBlocksStore = create<CustomBlocksState>((set, get) => ({
  blocks: [],
  isLoading: false,
  error: null,

  fetchCustomBlocks: async (category?: string) => {
    set({ isLoading: true, error: null });
    try {
      // TODO: Custom blocks feature is not yet implemented in the backend API
      // const result = await emailBuilderService.getCustomBlocks({
      //   category,
      // });
      // set({ blocks: result.items, isLoading: false, error: null });
      
      set({ 
        blocks: [], 
        isLoading: false, 
        error: "Custom blocks feature is not yet available" 
      });
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to fetch custom blocks";
      console.error('Error fetching custom blocks:', error);
      set({ error: errorMessage, isLoading: false, blocks: [] });
    }
  },

  saveCustomBlock: async (data) => {
    set({ error: null });
    try {
      // TODO: Custom blocks feature is not yet implemented in the backend API
      // const newBlock = await emailBuilderService.saveCustomBlock(data);
      // set((state) => ({
      //   blocks: [...state.blocks, newBlock],
      //   error: null,
      // }));
      
      throw new Error("Custom blocks feature is not yet available");
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to save custom block";
      console.error('Error saving custom block:', error);
      set({ error: errorMessage });
      throw error;
    }
  },

  deleteCustomBlock: async (id: string) => {
    set({ error: null });
    try {
      // TODO: Custom blocks feature is not yet implemented in the backend API
      // await emailBuilderService.deleteCustomBlock(id);
      // set((state) => ({
      //   blocks: state.blocks.filter((block) => block.id !== id),
      //   error: null,
      // }));
      
      throw new Error("Custom blocks feature is not yet available");
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to delete custom block";
      console.error('Error deleting custom block:', error);
      set({ error: errorMessage });
      throw error;
    }
  },

  reset: () => {
    set({ blocks: [], isLoading: false, error: null });
  },
}));
